export default class VisitPoint {
	constructor({
		name,
		identification,
		address,
		city,
		country,
		phone,
		cy,
		cx,
		id,
		typology_id,
		status_id,
		additional_info,
		typology_name,
		category_id,
		department,
	}) {
		this.name = name || "";
		this.identification = identification || "";
		this.address = address || "";
		this.city = city || "";
		this.country = country || "";
		this.department = department || "";
		this.phone = phone || "";
		this.cy = cy || "";
		this.cx = cx || "";
		// No requerid for create
		this.id = id || 0;
		this.typology_id = typology_id || 0;
		this.status_id = status_id || 0;
		this.additional_info = additional_info ? additional_info : {};
		if (typology_name) {
			this.typology_name = typology_name || "";
		}
		if (category_id) {
			this.category_id = category_id || 0;
		}
	}

	setAddtionalInfo(dataFields) {
		this.additional_info = {};
		const additionalProperties = dataFields.filter((property) => property.additional);
		additionalProperties.forEach((property) => {
			this.additional_info[property.name] = property.required === false ? null : "";
		});
	}

	/**
	 * retorna un array de objetos que contiene informacion de los campos dinamicos que se renderizan
	 * en el formulario de puntos de puntos de visita
	 * @param {*} tipology objeto que copntien la tipologia de donde se obtienen las propiedades adicionales
	 */
	dataModelDinamicFields(tipology) {
		if (!tipology) {
			return;
		}
		this.typology_id = tipology.typology_id;
		const dataFields = tipology.json_properties.filter((element) => element.additional);
		if (this.id === 0) {
			this.setAddtionalInfo(dataFields);
		}
		return [...dataFields];
	}
}
